import { Dialog } from "@mui/material";
import React from "react";

function ImagePreviewPopup({ isImagePreviewOpen, previewImage, handleClose }) {
    const imgSrc = previewImage instanceof Blob ? window.URL.createObjectURL(previewImage) : window.URL.createObjectURL(previewImage.blob);

    return (
        <Dialog id="ip_Dialog" open={isImagePreviewOpen} onClose={handleClose} onClick={handleClose}>
            <img id="ip_Img" width="300px" alt={previewImage.name} src={imgSrc} />
        </Dialog>
    );
}

export default ImagePreviewPopup;
